import { Option } from '../../../types';
import SelectedItemsComponent from '../SelectedItemsComponent/SelectedItemsComponent';
import List from './List/List';
import {
  EmptyView,
  StyledDropdownContainer,
  StyledInputField,
  StyledInputFieldWrapper,
  StyledSelectRestrictions,
  StyledWrapper,
} from './styled';

type Props = {
  selectedItems: Option[];
  loading: boolean;
  allItems: Option[];
  isAllowedToSelectAll?: boolean;
  total: number;
  maxSelectedItemsCount: number;
  handleSelectItem: (item: Option) => void;
  handleUnselectItem: (item: Option) => void;
  handleSelectAll: () => void;
  handleUnselectAll: () => void;
  handleSearch?: (value: string) => void;
  searchValue?: string;
  onNextPage?: () => void;
  showSelectionAndSearchBlock?: boolean;
  maxIsReachedText?: string;
};

const DropdownContainer = ({
  selectedItems,
  loading,
  allItems,
  isAllowedToSelectAll,
  total,
  maxSelectedItemsCount,
  handleSelectItem,
  handleUnselectItem,
  handleSelectAll,
  handleUnselectAll,
  handleSearch,
  searchValue,
  onNextPage,
  showSelectionAndSearchBlock = true,
  maxIsReachedText,
}: Props): JSX.Element => {
  if (!loading && !searchValue && total === 0) {
    return (
      <StyledDropdownContainer>
        <EmptyView data-testid="emptyView">No items found</EmptyView>
      </StyledDropdownContainer>
    );
  }

  return (
    <StyledDropdownContainer>
      {showSelectionAndSearchBlock && (
        <StyledWrapper data-testid="selectAndSearchContainer">
          {!isAllowedToSelectAll && (
            <StyledSelectRestrictions data-testid="selectRestrictionText">
              {selectedItems.length === maxSelectedItemsCount
                ? maxIsReachedText
                : `Select up to ${maxSelectedItemsCount}`}
            </StyledSelectRestrictions>
          )}
          <SelectedItemsComponent handleUnselectItem={handleUnselectItem} selectedItems={selectedItems} />
          {handleSearch && (
            <StyledInputFieldWrapper>
              <StyledInputField
                placeholder="Search by sales orders"
                defaultValue={searchValue}
                onChange={(event): void => {
                  handleSearch(event.target.value);
                }}
              />
            </StyledInputFieldWrapper>
          )}
        </StyledWrapper>
      )}

      <List
        loading={loading}
        selectedItems={selectedItems}
        allItems={allItems}
        total={total}
        maxSelectedItemsCount={maxSelectedItemsCount}
        showSelectAll={isAllowedToSelectAll}
        handleSelectAll={handleSelectAll}
        handleUnselectAll={handleUnselectAll}
        handleSelectItem={handleSelectItem}
        searchValue={searchValue}
        onNextPage={onNextPage}
      />
    </StyledDropdownContainer>
  );
};

export default DropdownContainer;
